import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from "recharts";

const currencyFmt = (v) => `${(v / 1000).toFixed(0)}k€`;

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const full = payload[0]?.payload?.fullName;
  return (
    <div className="bg-white dark:bg-slate-900 border rounded-lg shadow-lg px-3 py-2 text-xs max-w-[220px]">
      <p className="font-semibold mb-1">{full || label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} style={{ color: p.color }}>
          {p.name}: {p.value?.toLocaleString("es-ES", { minimumFractionDigits: 0, maximumFractionDigits: 0 })} €
        </p>
      ))}
    </div>
  );
}

/** Gráfico de barras: Concedido/devengado vs Cobrado en caja vs Incurrido acumulado, por proyecto. */
export function ConcedidoCobradoChart({ rows, year, height = 340 }) {
  const data = (rows || [])
    .filter((r) => r.external_year > 0 || r.collected_year > 0 || r.incurred_all > 0)
    .sort((a, b) => b.external_year - a.external_year)
    .slice(0, 12)
    .map((r) => ({
      name: r.name.length > 20 ? `${r.name.slice(0, 19)}…` : r.name,
      fullName: r.name,
      Concedido: r.external_year,
      "Cobrado en caja": r.collected_year,
      "Incurrido acumulado": r.incurred_all,
      pending: r.pending_concedido_verification,
    }));

  if (!data.length) return null;

  return (
    <div className="w-full" data-testid="concedido-cobrado-chart">
      <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-2">
        Concedido {year} vs Cobrado en caja {year} vs Incurrido acumulado, por proyecto
      </div>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis
            dataKey="name"
            tick={{ fontSize: 10, fill: "#64748b" }}
            angle={-55}
            textAnchor="end"
            interval={0}
            height={90}
          />
          <YAxis tickFormatter={currencyFmt} tick={{ fontSize: 11, fill: "#64748b" }} width={48} />
          <Tooltip content={<ChartTooltip />} />
          <Legend wrapperStyle={{ fontSize: 12, paddingTop: 4 }} verticalAlign="top" height={28} />
          <Bar dataKey="Concedido" radius={[3, 3, 0, 0]}>
            {data.map((d, i) => (
              <Cell key={i} fill={d.pending ? "#fbbf24" : "#d97706"} />
            ))}
          </Bar>
          <Bar dataKey="Cobrado en caja" fill="#0d9488" radius={[3, 3, 0, 0]} />
          <Bar dataKey="Incurrido acumulado" fill="#64748b" radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      <div className="text-[10px] text-muted-foreground mt-1">
        Barras de "Concedido" en ámbar claro = valor aún pendiente de verificación oficial (ver tabla). "Incurrido acumulado"
        = gasto real ejecutado desde el inicio del proyecto (todos los años), para ver el estado real de ejecución.
        Mostrando hasta 12 proyectos con más importe concedido.
      </div>
    </div>
  );
}
